import { render, staticRenderFns } from "./ItemsListDashboard.vue?vue&type=template&id=3e284dbf&scoped=true&"
import script from "./ItemsListDashboard.vue?vue&type=script&lang=ts&"
export * from "./ItemsListDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsListDashboard.vue?vue&type=style&index=0&id=3e284dbf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e284dbf",
  null
  
)

export default component.exports